import {useNotificationsStore} from "@/stores/notifications";

export default {

    showNotification(message, notificationType){
        let notification = [
            {
                'message': message,
                'type': notificationType
            }
        ]

        console.log("ErrorMessage", message)
        useNotificationsStore().sendNotification(notification)
        useNotificationsStore().removeNotificationFromTimeout()
    },

    /*
     * Muestra el error devuelto por la API. Admite `errors` como array o como
     * objeto de validación de Laravel y usa `fallbackMessage` si no hay respuesta
     * (p. ej. errores de red).
     */
    showApiError(error, fallbackMessage){
        const data = error?.response?.data
        const errors = data?.errors
        const messages = Array.isArray(errors) ? errors : Object.values(errors ?? {}).flat()
        const message = messages.length ? messages.join(' ') : (data?.message || fallbackMessage)

        this.showNotification(message, "error")
    }

}